import { UPDATE } from 'react-admin';

export const CHECKIN_TICKET = 'CHECKIN_TICKET';
export const checkinTicket = (id, data, basePath) => ({
    type: CHECKIN_TICKET,
    payload: { id, data: { ...data, scanned_at: true } },
    meta: { fetch: UPDATE, resource: 'tickets' },
});